<div class="container">
    <div class="header">
        <h5 class="title">
            {{
                (data.mode
                    ? 'duty-engineer.edit-duty-engineer.dialog.title'
                    : 'duty-engineer.add-duty-engineer.dialog.title'
                ) | translate
            }}
        </h5>
    </div>
    <div class="content">
        <div class="input-container" [class.error]="nameAlreadyExists">
            <span class="input-name">
                {{ 'duty-engineer.add-duty-engineer.dialog.name' | translate }}
            </span>
            <app-channel-text-input
                [name]="ACCOUNT_NAME"
                label="duty-engineer.add-duty-engineer.dialog.name.label"
                [value]="name"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [inputError]="validationErrors?.name"
                [maxLength]="20">
            </app-channel-text-input>
        </div>

        <div class="input-container" [class.error]="abbreviationAlreadyExists">
            <span class="input-name">
                {{ 'duty-engineer.add-duty-engineer.dialog.abbreviation' | translate }}
            </span>
            <app-channel-text-input
                [name]="ACCOUNT_ABBREVIATION"
                label="duty-engineer.add-duty-engineer.dialog.abbreviation.label"
                [value]="abbreviation"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [inputError]="validationErrors?.abbreviation"
                [maxLength]="8">
            </app-channel-text-input>
        </div>
        <div class="input-container" *ngIf="data.controlType === DutyEngineerControlMode.CONSOLE_CONTROL">
            <span class="input-name">{{ 'duty-engineer.add-duty-engineer.dialog.input' | translate }}</span>
            <app-address-selectors
                [vesselSlots]="vesselSlots"
                [settingAddress]="settingAddress"
                [hasRowPadding]="false"
                (onSelectorChange)="onSelectorChange($event)"></app-address-selectors>
        </div>
    </div>
</div>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>

<div class="buttons-container">
    <button class="cancel button" data-cy="ops-settings-duty-engrs-modal-cancel-button" (click)="cancelClick()">
        {{ 'shipyard.create.dialog.form.button.cancel' | translate }}
    </button>
    <button
        class="create button"
        data-cy="ops-settings-duty-engrs-modal-submit-button"
        [disabled]="isCreatingDisabled()"
        (click)="createButtonClick()">
        {{
            (data.mode
                ? 'duty-engineer.add-duty-engineer.dialog.edit'
                : 'duty-engineer.add-duty-engineer.dialog.create'
            ) | translate
        }}
    </button>
</div>
